export default "__VITE_ASSET__CJe9zQOZ__"